import { replaceLastApiPath } from '../url/publicUrl';

const PUBLIC_API_PREFIX = '/api-endpoint/external/';

/**
 * string-based equivalent of getPublicApiURL for server-side usage.
 * replaces the last /api/ with /api-endpoint/external/ in the url path.
 */
export const getPublicApiURLString = (url: string): string =>
  replaceLastApiPath(url, PUBLIC_API_PREFIX);
